import { useSelector } from 'react-redux';
import { selector } from 'selectors/busy';

const useIsBusy = (actionConst) => {
  return useSelector((state) => selector(state, actionConst));
};

export default useIsBusy;
